import _ from 'lodash';
import {bbox as turfBBox} from '@turf/turf';

export function prepareOverlayGeometry(overlaysData, skipOverlayCheck = false) {
  let bounds = [];
  const overlays = [];
  const featureCollection = {type: 'FeatureCollection', features: []};
  _.each(overlaysData, (overlay) => {
    const overlayType = _.get(overlay, 'properties.overlay_type');
    if (overlayType !== 'folio_by_id') {
      overlays.push(overlay);
    }
    if (overlayType === 'place' || skipOverlayCheck) {
      featureCollection.features.push({
        type: 'Feature',
        properties: {},
        geometry: overlay,
      });
    }
  });
  if (featureCollection.features.length) {
    bounds = turfBBox(featureCollection);
  }
  return {bounds, overlays};
}

export function fitBounds(map, bounds, leftOffset = 20) {
  try {
    map.fitBounds(
      [
        [bounds[0], bounds[1]],
        [bounds[2], bounds[3]],
      ],
      {
        padding: {
          bottom: 20,
          left: leftOffset,
          right: 20,
          top: 20,
        },
        linear: true,
        maxZoom: 18,
        duration: 0,
      },
    );
  }
  catch (e) {
    console.error('Wrong bounds.', {e});
  }
}

export function leftPanelWidth() {
  const leftPanel = document.querySelector('.left-overlay-map');
  return leftPanel ? parseInt(window.getComputedStyle(leftPanel).width, 10) : 0;
}
